// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__RadioColumn__radio{margin:0}", "",{"version":3,"sources":["webpack://./../../../../src/datatable/columns/RadioColumn.module.scss","webpack://./../../platform/@jutro/legacy/datatable/columns/RadioColumn.module.css"],"names":[],"mappings":"AAAA,yBACE,QCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radio": "jut__RadioColumn__radio"
};
export default ___CSS_LOADER_EXPORT___;
